import React from "react";
import {Route, Switch} from "react-router-dom";
import Standards from "./standards";
import Projects from "./projects";
import Setting from "./setting";
import ProtectedRoute from "../../components/ProtectedRoute";
const BaseData = ({match}) => (
  <Switch>
    <ProtectedRoute path={`${match.url}/projects`} component={Projects}/>
    <ProtectedRoute path={`${match.url}/standards`} component={Standards}/>
    <ProtectedRoute path={`${match.url}/setting`} component={Setting}/>
  </Switch>
);

export default BaseData;
